import React from "react";
import styled from "styled-components";
import { BloxButton } from "styled_components/Common/BloxButton";
import format from "date-fns/format";
import { getTicketTitle } from "utils/SupportUtils";
import { Utils } from "services/utils";
import { Divider } from "styled_components/Common/Divider";

const TicketLocationStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 110px;
  flex: 1;
  background: ${(props) => props.theme.componentBackground};
  color: ${(props) => props.theme.defaultFontColor};
  .status-display {
    position: absolute;
    right: 0px;
    top: -18px;
    display: flex;
    .status {
      margin-left: 5px;
    }
  }
  .left {
    flex: 0.5;
    height: 100%;
    //border: 1px solid green;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #dee1e2;
    img {
      width: 40px;
      height: 40px;
    }
    .title {
      margin-top: 5px;
      margin-bottom: 10px;
      text-transform: capitalize;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    padding: 10px;
    .row {
      display: flex;
      align-items: center;
      position: relative;
      width: 100%;
      height: 23px;
      .label {
        margin-right: 5px;
      }
      .location {
        text-transform: uppercase;
      }
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 135px;
    .status-display {
      right: 0px;
      top: -26px;
      .status {
        margin-left: 5px;
      }
    }
    .left {
      width: 125px;
      min-width: 125px;
      img {
        width: 40px;
        height: 40px;
      }
      .title {
        margin-top: 5px;
        margin-bottom: 15px;
      }
    }
    .right {
      padding: 15px;
      .row {
        width: 100%;
        height: 28px;
        .label {
          margin-right: 10px;
        }
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    .status-display {
      right: 0px;
      top: -32px;
      .status {
        margin-left: 10px;
      }
    }
    .left {
      img {
        width: 60px;
        height: 60px;
      }
      .title {
        margin-top: 10px;
        margin-bottom: 25px;
      }
    }
    .right {
      padding: 15px;
      .row {
        height: 58px;
        .label {
          margin-right: 20px;
        }
      }
    }
  }
`;

export const TicketLocation = ({ icon, onCancelRequest, ticketDetails }) => {
  const dateTimeFormat = format(
    new Date(ticketDetails?.created_date_time),
    "MM-dd-yyyy HH:mm "
  );

  const getTicketStatus = (status) => {
    return status ? status.charAt(0).toUpperCase() + status.slice(1) : "";
  };
  const closedTicket =
    ticketDetails?.status === "Closed" || ticketDetails?.status === "Solved";

  return (
    <TicketLocationStyle className="ticket-location-wrapper">
      <div className="status-display ">
        <div className="label labels21">STATUS:</div>
        <div className="status labels21">
          {getTicketStatus(ticketDetails?.status)}
        </div>
      </div>
      <div className="left">
        <img src={icon} alt="ticket type" />
        <div className="title heading70">
          {getTicketTitle(ticketDetails?.title)}
        </div>
        {!closedTicket && (
          <BloxButton
            className="buttons41"
            id="cancel-ticket"
            text="CANCEL"
            module="support"
            enabled={true}
            onClick={onCancelRequest}
            cypressId="ticket-cancel-button"
          />
        )}
      </div>
      <div className="right">
        <div className="row">
          <div className="label labels21">Requester :</div>
          <div className="footer20">{ticketDetails?.requester}</div>
        </div>
        <div className="row">
          <Divider />
          <div className="label labels21">Date / Time :</div>
          <div className="footer20">{dateTimeFormat}</div>
        </div>
        <div className="row">
          <Divider />
          <div className="label labels21">Priority :</div>
          <div className="footer20">
            {Utils.getPriorityString(ticketDetails?.priority)}
          </div>
        </div>
        <div className="row">
          <Divider />
          <div className="label labels21">Location :</div>
          <div className="location footer20">{ticketDetails?.location}</div>
        </div>
      </div>
    </TicketLocationStyle>
  );
};
// LargeInfoDisplay.propTypes = {
// 	type: string.isRequired,
// };

// LargeInfoDisplay.defaultProps = {};
